import { createRouter, createWebHistory } from 'vue-router'

import Index from '../components/Index.vue';

const router = createRouter({
  history: createWebHistory(),
  mode: 'history',
  base: '/',
  routes: [
    { path: '/konfigurator', name: 'konfigurator', component: Index },
    { path: '/hausnotruf', name: 'hausnotruf', component: Index },
    { path: '/', name: 'default', component: Index }, // For local setup,
    { path: '/vue-3/demo/care-consulting/', name: 'demo', component: Index }, // For live demo setup
    { path: '/vue-3/care-consulting/', name: 'live', component: Index }, // For live white labels setup
    { path: '/care-consulting/', name: 'default-live', component: Index } // WDN-1727
  ]
})

export default router
